module.exports = __webpack_public_path__ + "img/logo_Nawasco.c74b4063.svg";